<script setup lang="ts">
/**
 * A window's maximise button (lib/windows.ts), beside its – : fills the screen
 * above the taskbar, or puts it back where it was. Not on a phone, where the
 * window in front fills the screen already (styles.css hides it).
 */
import { computed } from "vue";
import { toggleMaximize, windows } from "../lib/windows.js";

const props = defineProps<{ winKey: string }>();
const max = computed(() => windows.value.find((w) => w.key === props.winKey)?.max ?? false);
</script>

<template>
  <button
    class="btn ghost win-max"
    type="button"
    :title="max ? 'Restore its size' : 'Maximise — fill the screen'"
    :aria-label="max ? 'Restore' : 'Maximise'"
    :aria-pressed="max"
    @click.stop="toggleMaximize(winKey)"
  >{{ max ? "❐" : "▢" }}</button>
</template>
